module.exports = __webpack_public_path__ + "img/selected1-min.8ea65ab9.png";